import { ReactNode } from 'react'
import { SectionWithListWithAssetPageSchema } from 'cms/schemaTypes/staticPages/documents/sectionListWithAsset'
import { SectionWithImagePageSchema } from 'cms/schemaTypes/staticPages/documents/sectionWithImage'
import Image from 'next/image'

import { urlFor } from 'lib/sanity/image'
import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'
import { mobileBreakPoint } from 'shared/ui/utils/breakpoints'

import HowItWorks from '../../components/deliveryInfo/HowItWorks'
import {
  InfoBox,
  PageTitle,
  SectionContainer,
  SectionTitle
} from '../../components/landings/styles'

import styles from './DeliveryTime.module.scss'

interface DeliveryTimeProps {
  texts: {
    header: string
  }
  deliveryMethodsSectionList: SectionWithImagePageSchema[]
  infoBox: string | ReactNode
  howItWorks: SectionWithListWithAssetPageSchema
}

const DeliveryTime = ({
  texts,
  deliveryMethodsSectionList,
  infoBox,
  howItWorks
}: DeliveryTimeProps) => {
  return (
    <>
      <SectionContainer $condensed>
        <PageTitle className={styles.pageTitle}>
          <FormattedText text={texts.header} />
        </PageTitle>
        <div className={styles.methodsWrapper}>
          {deliveryMethodsSectionList.map(section => (
            <div key={section.header} className={styles.methodSection}>
              <div className={styles.methodImageWrapper}>
                <Image
                  className={styles.methodImage}
                  src={urlFor(section.image.asset).url()}
                  alt={section.image.asset.alt}
                  width={325}
                  height={150}
                  quality={100}
                  sizes={`(max-width: ${mobileBreakPoint}px) 100vw, 325px`}
                />
              </div>
              <div className={styles.methodTextContent}>
                <SectionTitle>
                  <FormattedText text={section.header} />
                </SectionTitle>
                <div className={styles.methodDescription}>
                  <CustomPortableText value={section.content || ''} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </SectionContainer>
      <SectionContainer $condensed>
        <InfoBox>{infoBox}</InfoBox>
      </SectionContainer>
      <HowItWorks content={howItWorks} />
    </>
  )
}

export default DeliveryTime
